import script from "./HrWorkforceProfileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceProfileTab.vue?vue&type=script&setup=true&lang=js"

import "./common/hrWorkforce.css?vue&type=style&index=0&id=10a2fb52&scoped=true&lang=css"
import "./HrWorkforceProfileTab.vue?vue&type=style&index=1&id=10a2fb52&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a2fb52"]])

export default __exports__